import getObjectKey from 'lib/object/getObjectKey'
import { capitalise } from 'lib/string/stringUtils'
import type { IntlShape } from 'react-intl'

interface FormatPaymentScheduleFrequencyOptions {
  capitalized?: boolean
}

export function getPaymentScheduleKey(payload: App.Checkout.PaymentScheduleRequestInfo | App.Checkout.PaymentScheduleAdjustmentRequestInfo | null): string {
  if (!payload) {
    return 'default'
  }

  return getObjectKey(payload)
}

export function formatPaymentScheduleFrequency(
  intl: IntlShape,
  frequency?: string,
  options: FormatPaymentScheduleFrequencyOptions = {},
): string {
  if (!frequency) {
    return ''
  }

  const normalizedFrequency = frequency.toLowerCase()

  const localizedFrequency = (() => {
    switch (normalizedFrequency) {
      case 'weekly':
        return intl.formatMessage({
          id: 'Fv5lpVZRiOG42gBbCPsr',
          defaultMessage: 'weekly',
          description: 'Payment schedule frequency label for weekly instalment and deposit payment options',
        })
      case 'fortnightly':
        return intl.formatMessage({
          id: 'AlJEi-crCXgaJfFiKSfL',
          defaultMessage: 'fortnightly',
          description: 'Payment schedule frequency label for fortnightly instalment and deposit payment options',
        })
      case 'monthly':
        return intl.formatMessage({
          id: 'Ps02IYEsFrUBb9AoXdYq',
          defaultMessage: 'monthly',
          description: 'Payment schedule frequency label for monthly instalment and deposit payment options',
        })
      default:
        return frequency
    }
  })()

  return options.capitalized ? capitalise(localizedFrequency) : localizedFrequency
}
